import { Cell, initialState } from '../user'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const subscriptionSlice = createSlice({
  name: 'userSubGroup',
  initialState,
  reducers: {
    setSubscriptionSubGroup(state, action: PayloadAction<Cell[]>) {
      state.value = action.payload
    },
  },
})

export const { setSubscriptionSubGroup } = subscriptionSlice.actions
export default subscriptionSlice.reducer
